// extracted by mini-css-extract-plugin
module.exports = {"root":"AssetsInputPreview_root__2Z0Ux","remove":"AssetsInputPreview_remove__825NX","alt":"AssetsInputPreview_alt__8e_dI"};